<template>
    <v-card class="main-card">
        <v-card-title class="primary title white--text">
            Time Series Plots
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 fill-height>
                    <div class="leftside">
                        <points-draggable></points-draggable>
                    </div>
                    <div class="rightside">
                        <div class="pa-2">
                            <v-layout row wrap>
                                <v-flex xs4>
                                    <date-range-selector v-model="range"></date-range-selector>
                                </v-flex>
                                <v-flex xs4>
                                    <v-switch
                                            v-model="onOnly"
                                            label="View Points when Chiller is On"
                                    ></v-switch>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="primary"
                                        @click="newPlotsName=null; dialog=true"
                                >
                                    <v-icon class="mr-2">fa-save</v-icon>
                                    Save
                                </v-btn>
                                <v-dialog v-model="dialog" max-width="300">
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            Save current plots
                                        </v-card-title>
                                        <v-card-text>
                                            <v-text-field label="Name" autofocus v-model="newPlotsName" required></v-text-field>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="primary" @click="savePlots" :disabled="!newPlotsName||newPlotsName===''">OK</v-btn>
                                            <v-btn @click="dialog=false">Cancel</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>
                        </div>
                        <plot-and-selector
                                :on-only="onOnly"
                                :date-range="range"
                                ref="selectorplots"
                                v-for="(i,j) in plotCounts"
                                v-if="i"
                                :key="j"
                        ></plot-and-selector>
                        <v-btn class="accent" @click="addPlot" block large>
                            <v-icon>
                                fa-plus
                            </v-icon>
                            Add Plots
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
    import PointsDraggable from '../components/multiplots/PointsDraggable'
    import PlotAndSelector from '../components/multiplots/PlotAndSelector'
    import DateRangeSelector from '../components/DateRangeSelector'
    import moment from 'moment'

    export default {
        name: 'MultiPlots',
        components: {DateRangeSelector, PlotAndSelector, PointsDraggable},
        data() {
            return {
                range: null,
                dialog:false,
                onOnly: false,
                newPlotsName:null,
                plotCounts: [true]
            }
        },
        methods: {
            addPlot() {
                this.plotCounts.push(true)
            },
            uniqueid() {
                let ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
                let ID_LENGTH = 8;
                let rtn = '';
                for (let i = 0; i < ID_LENGTH; i++) {
                    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
                }
                return rtn;
            },
            savePlots() {
                let newConfig=this.getPlotsCofig()
                let me=this
                if(newConfig.length>0){
                    let newPlot={
                        id: this.uniqueid(),
                        viewType: "plot-list",
                        facility:me.$store.state.pointsListStore.pointsList.facility_name,
                        title: this.newPlotsName,
                        linkTitle: this.newPlotsName,
                        hasOnOnlySwitch: true,
                        plotList: newConfig
                    }
                    this.$store.dispatch('addUserPlot', newPlot).then(function(){
                        me.$store.dispatch('callSnackbar', {text: 'Plots saved'})
                    })
                }
                this.dialog=false
            },
            getPlotsCofig(){
                let plotConfig = []
                if (this.$refs.selectorplots) {
                    for (let plot of this.$refs.selectorplots) {
                        if (plot.selectedVar && plot.selectedVar.length > 0) {
                            plotConfig.push({
                                'id': plot._uid,
                                'type': 'multi-chart',
                                'config': {
                                    'layout-overrides': {
                                        xaxis: {
                                            title: "Time "
                                        },
                                        legend: {
                                            orientation: 'h',
                                            y: -0.2
                                        },
                                    },
                                    'variables-list': plot.selectedVar.map(function (selectedVar) {
                                        return ({
                                            equipment_name: selectedVar.equipment_name,
                                            name: selectedVar.name,
                                        })
                                    }),
                                }
                            })
                        }

                    }
                }
                return plotConfig
            }
        },
        computed: {
            totalPoints() {
                let output = 0
                for (let i in this.$store.state.pointsListStore.pointsList.sensors) {
                    output += this.$store.state.pointsListStore.pointsList.sensors[i].length
                }
                return output
            }
        },
        beforeMount() {
            let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
            if (maxDate) {
                this.range = {
                    start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                    end: moment(maxDate).format('YYYY-MM-DD')
                }
            }
        }
    }
</script>

<style scoped>
    .leftside {
        width: 20%;
        height: 80vh;
        float: left;
        overflow-y: scroll;
    }

    .rightside {
        width: 80%;
        float: right;
        height: 80vh;
        overflow-y: scroll;
    }

    .main-card {
        width: 100%;
    }
</style>
